import React from 'react';
import PropTypes from 'prop-types';

const TabItem = ({className, label, ...props}) => {

  return (
    <div className={className} label={label} {...props}>
      {this.props.children}
    </div>
  );
};

TabItem.propTypes = {
  className: PropTypes.string,
  label: PropTypes.any.isRequired,
};

TabItem.defaultProps = {
  className: '',
};

export default TabItem;




// WEBPACK FOOTER //
// ./js/components/global/tabs/TabItem.js